import { initializeApp } from 'firebase/app'
import { getMessaging, isSupported } from 'firebase/messaging'
import config from './config'

const app = initializeApp(config.firebase.web)

export const messagingPromise = isSupported()
	.then(supported => (supported ? getMessaging(app) : null))
	.catch(() => null)
